export default __webpack_public_path__ + "static/media/39.3d585096.jpg";